import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { ZInput } from "@/components/ZInput";
import ZButton from "@/components/ZButton";
import { Lock } from "lucide-react";

export default function RedeemPage() {
  const { user } = useAuth();
  const nav = useNavigate();
  const [code, setCode] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (!user) {
      nav("/login");
      return;
    }
    setLoading(true);
    try {
      const r = await api.post("/invitations/redeem", { code: code.trim() });
      nav(`/ticket/${r.data.ticket.id}`);
    } catch (e) {
      setErr(errMsg(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="z-container" style={{ maxWidth: 460 }} data-testid="redeem-page">
      <h1 className="z-page-title">Code d'invitation</h1>
      <p className="z-page-sub">Vous avez reçu un code pour un événement privé ? Saisissez-le ici.</p>

      <form onSubmit={submit} className="z-card" style={{ padding: 24 }}>
        <div style={{ display: "flex", justifyContent: "center", marginBottom: 18 }}>
          <div className="z-role-icon"><Lock size={26} /></div>
        </div>
        <ZInput
          label="Code"
          value={code} onChange={(e) => setCode(e.target.value.toUpperCase())}
          placeholder="EX. AB3CD7XY" required
          style={{ textAlign: "center", fontFamily: "monospace", letterSpacing: 2, fontSize: 18 }}
          data-testid="redeem-code-input"
        />
        {!user && (
          <p style={{ background: "rgba(218,113,1,0.10)", color: "var(--z-orange)", padding: 10, borderRadius: 10, fontSize: 13, marginBottom: 14 }}>
            Connexion requise pour valider un code d'invitation.
          </p>
        )}
        {err && <p className="z-error-text" data-testid="redeem-error">{err}</p>}
        <ZButton type="submit" block loading={loading} data-testid="redeem-submit-btn">
          {user ? "Valider le code" : "Se connecter"}
        </ZButton>
      </form>
    </div>
  );
}
